import { getContractBasedDataSelector } from '@cp-shared-10/frontend-integration';
import { RootState } from 'store/rootReducer';

export const PaymentDetailsDataSelector = getContractBasedDataSelector((state: RootState) => state.paymentDetails);
